import {
	createBrowserRouter,
	createRoutesFromElements,
	RouterProvider,
	Route
} from "react-router-dom";
import Home from "./components/Home";
import Cart from "./components/Cart";
import Pending from "./components/Pending";
import Header from "./components/Header";
import NotFound from "./components/NotFound";
import Customer from "./components/Customer";
import ErrorMessage from "./components/ErrorMessage";
import {routeCheck} from "./utils/RouteUtil";
// import Payment from "./components/Payment";
import Order from "./components/Cart/Order";
import ClosedNotice from "./components/ClosedNotice";

const router = createBrowserRouter(
	createRoutesFromElements(
		<>
			<Route
				path="/"
				element={<Header />}
				errorElement={
					<ErrorMessage
						message="Something, found went wrong!."
						sub_message="Scan QR code again."
					/>
				}
			>
				<Route
					path="order/:rid/:tid"
					loader={({ params }) => routeCheck(params)}
					element={<Home />}
				/>
				<Route path="customer-details/:rid/:tid" element={<Customer />} />
				<Route
					path="cart/:rid/:tid"
					loader={({ params }) => routeCheck(params)}
					element={<Cart />}
				/>
				<Route
					path="create-order/:rid/:tid"
					loader={({ params }) => routeCheck(params)}
					element={<Order />}
				/>
				<Route
					path="order-status/:rid/:tid"
					loader={({ params }) => routeCheck(params)}
					element={<Pending />}
				/>
				{/* <Route path="/payment/:rid/:tid/:pid" element={<Payment />} /> */}
				<Route path="/" element={<NotFound />} />
			</Route>
			<Route path="/restaurant-closed/:rid/:tid" element={<ClosedNotice />} />
			<Route path="*" element={<NotFound />} />
		</>
	)
);

function App() {
	return <RouterProvider router={router} />;
}

export default App;
